<template>
  <div class="step-form">
    <div class="step-form-section">
      <div class="inner-container">
        <div class="input-group">
          <label>{{ $t("labels.area") }}</label>
          <multiselect
            v-model="areaVModel"
            class="select-custom"
            mode="multiple"
            :multiple-label="areaSelectedCount"
            @open="onAreaPopupOpen"
            ref="areaMultiselect"
            :placeholder="$t('placeholders.select')"
            :options="areasOptions"
            @clear="onAreasCleared"
          >
            <template v-slot:caret>
              <span class="multiselect-caret-custom">
                <i class="far fa-chevron-down"></i>
              </span>
            </template>
          </multiselect>
          <modal
            :draggable="false"
            :resizable="false"
            :adaptive="true"
            :width="440"
            :scrollable="true"
            height="auto"
            name="area"
          >
            <area-modal :areas="areas" @closeModal="$modal.hide(`area`)"></area-modal>
          </modal>
        </div>
      </div>
      <div class="inner-container">
        <div class="input-group">
          <label>{{ $t("labels.destiny") }}</label>
          <multiselect
            v-model="destinyVModel"
            class="select-custom"
            mode="multiple"
            :multiple-label="destinySelectedCount"
            @open="onDestinyPopupOpen"
            ref="destinyMultiselect"
            :placeholder="$t('placeholders.select')"
            :options="destiniesOptions"
            @clear="onDestiniesCleared"
          >
            <template v-slot:caret>
              <span class="multiselect-caret-custom">
                <i class="far fa-chevron-down"></i>
              </span>
            </template>
          </multiselect>
          <modal
            :draggable="false"
            :resizable="false"
            :adaptive="true"
            :width="440"
            :scrollable="true"
            height="auto"
            name="destiny"
          >
            <destiny-modal
              :destinies="destinies"
              @closeModal="$modal.hide(`destiny`)"
            ></destiny-modal>
          </modal>
        </div>
      </div>
    </div>
    <div class="step-form-section">
      <div class="inner-container">
        <div class="form-group">
          <label for="budgetFrom">
            {{ $t("labels.budget") }}
          </label>
          <div style="margin-top: 24px; margin-bottom: 24px">
            <slider
              v-if="budget.length"
              v-model="budget"
              class="slider-custom"
              :step="sliderConfig.step"
              :min="sliderConfig.min"
              :max="sliderConfig.max"
              :merge="sliderConfig.merge"
              :tooltip-position="sliderConfig.tooltipPosition"
              :format="sliderConfig.sliderFormat"
              @update="budgetSliderUpdate"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="step-form-section">
      <div class="inner-container">
        <div class="form-group">
          <label>
            {{ $t("labels.additionalEquipment") }}
          </label>
          <div class="equipment-wrapper">
            <div
              class="equipment-tile"
              :class="{ selected: selectedEquipment.includes(equip.id) }"
              v-for="equip in equipment"
              :key="equip.name"
              @click="selectEquipment(equip.id)"
            >
              <img
                :src="require(`@/assets/images/${equip.icon}.svg`)"
                :alt="`Ikona ${equip.name}`"
              />
              <span>{{ equip.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="expandable-section">
      <div
        ref="advancedFiltersRef"
        class="expandable-section-btn"
        @click="toogleAdvancedFiltersVisibility"
      >
        <span>
          {{ $t("labels.advancedFilters") }}
        </span>
        <i :class="advancedFiltersVisible ? 'far fa-chevron-up' : 'far fa-chevron-down'"></i>
      </div>
      <transition name="fade">
        <advanced-filters v-show="advancedFiltersVisible" />
      </transition>
    </div>
  </div>
</template>
<script>
// vuex
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";

// components
import AdvancedFilters from "./AdvancedFilters.vue";
import Slider from "@vueform/slider/dist/slider.vue2.js";
import AreaModal from "./AreaModal.vue";
import DestinyModal from "./DestinyModal.vue";
import Multiselect from "@vueform/multiselect/dist/multiselect.vue2.js";

// css
import "./StepForm.scss";

// methods
import setCookie from "@/utils/setCookie";
import updateUrlParams from "@/router/middleware/updateUrlParamsMiddleware";

// enums
import { genderEnum } from "@/enums/genderEnum";

// axios
import api from "@/axios.config.js";

export default {
  name: "SecondStepForm",
  props: {
    advancedFiltersOpen: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      equipment: [],
      genderEnum,
      sliderConfig: {
        min: 0,
        max: 30000,
        step: 500,
        merge: 2000,
        tooltipPosition: "bottom",
        sliderFormat: function (value) {
          var parts = value.toString().split(".");
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
          return parts.join(".");
        },
      },
      advancedFiltersVisible: false,
      areasOptions: [],
      destiniesOptions: [],
    };
  },
  computed: {
    ...mapFields([
      "filters.budget",
      "filters.selectedEquipment",
      "filters.mainArea",
      "filters.optionalAreas",
      "filters.mainDestiny",
      "filters.optionalDestinies",
      "areas",
      "destinies",
    ]),
    areaVModel: {
      set(newVal) {
        return newVal;
      },
      get() {
        return [this.mainArea, ...this.optionalAreas];
      },
    },
    destinyVModel: {
      set(newVal) {
        return newVal;
      },
      get() {
        return [this.mainDestiny, ...this.optionalDestinies];
      },
    },
  },
  watch: {
    budget: function (newVal) {
      setCookie("budget", newVal.join(), this);
      updateUrlParams();
    },
    mainArea: function (newVal) {
      if (newVal === "0" || newVal === 0) this.mainArea = null;
      setCookie("mainArea", +newVal, this);
      updateUrlParams();
    },
    optionalAreas: function (newVal) {
      setCookie("optionalAreas", newVal.join(), this);
      updateUrlParams();
    },
    mainDestiny: function (newVal) {
      if (newVal === "0" || newVal === 0) this.mainDestiny = null;
      setCookie("mainDestiny", +newVal, this);
      updateUrlParams();
    },
    optionalDestinies: function (newVal) {
      setCookie("optionalDestinies", newVal.join(), this);
      updateUrlParams();
    },
  },
  methods: {
    ...mapActions(["getAreas", "getDestinies"]),
    windowResizeHandler: function () {
      var width =
        window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (width > 600) {
        this.sliderConfig.merge = 2000;
      } else {
        this.sliderConfig.merge = 6000;
      }
    },
    onAreaPopupOpen: function (e) {
      this.$refs.areaMultiselect.close();
      this.showAreas();
    },
    onDestinyPopupOpen: function (e) {
      this.$refs.destinyMultiselect.close();
      this.showDestinies();
    },
    budgetSliderUpdate: function (e) {
      this.budget = e;
    },
    toogleAdvancedFiltersVisibility: function () {
      this.advancedFiltersVisible = !this.advancedFiltersVisible;
      if (this.advancedFiltersVisible) this.scrollToAdvancedFilters();
    },
    // adding/ removing from selected equipment filter
    selectEquipment(id) {
      // if clicked equipment is already chosen then remove it from chosen equipment
      if (this.selectedEquipment.includes(id)) {
        for (let i = 0; i < this.selectedEquipment.length; i++) {
          if (this.selectedEquipment[i] === id) {
            this.selectedEquipment.splice(i, 1);
            break;
          }
        }
      }
      // if clicked equipment wasn't choose then add it to chosen equipment
      else {
        this.selectedEquipment.push(id);
      }
      updateUrlParams();
    },
    // used in mounted hook. Retrieves filters values from browser cookies
    getCookies() {
      const budget = this.$cookies.get("budget");
      if (budget) {
        let cookieBudget = budget.split(",");
        if (cookieBudget) {
          for (let i = 0; i < cookieBudget.length; i++) {
            cookieBudget[i] = +cookieBudget[i];
          }
          this.budget = cookieBudget;
        }
      }

      const selectedEquipment = this.$cookies.get("selectedEquipment");
      if (selectedEquipment) {
        // selected equipment IDs are saved in cookies as string with commas
        // so here I make an array of strings of it
        let cookieSelectedEquipment = selectedEquipment.split(",");
        if (cookieSelectedEquipment) {
          for (let i = 0; i < cookieSelectedEquipment.length; i++) {
            // changing array of strings to array of numbers
            cookieSelectedEquipment[i] = +cookieSelectedEquipment[i];
          }
          // assign prepared array of numbers to Vuex store field
          this.selectedEquipment = cookieSelectedEquipment;
        }
      }
    },
    scrollToAdvancedFilters() {
      const HEADER_HEIGHT = 74;
      const element = this.$refs.advancedFiltersRef;

      function scrollToTargetAdjusted(element) {
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition - HEADER_HEIGHT;

        window.scrollBy({
          top: offsetPosition,
          behavior: "smooth",
        });
      }
      scrollToTargetAdjusted(element);
    },
    showAreas() {
      this.$modal.show("area");
    },
    showDestinies() {
      this.$modal.show("destiny");
    },
    // count how much areas are currently selected and return multiselect placeholder
    areaSelectedCount: function () {
      let count = 0;
      if (this.mainArea) {
        count = 1;
      }
      if (this.optionalAreas && this.optionalAreas.length) {
        count += this.optionalAreas.length;
      }

      if (count > 0) {
        if (count === 1) {
          return this.$t("labels.oneOptionSelected", [count]);
        } else if (count > 1 && count < 5) {
          return this.$t("labels.optionSelected", [count]);
        } else if (count >= 5) {
          return this.$t("labels.optionsSelected", [count]);
        }
      }
    },
    // count how much destinies are currently selected and return multiselect placeholder
    destinySelectedCount: function () {
      let count = 0;
      if (this.mainDestiny) {
        count = 1;
      }
      if (this.optionalDestinies && this.optionalDestinies.length) {
        count += this.optionalDestinies.length;
      }

      if (count > 0) {
        if (count === 1) {
          return this.$t("labels.oneOptionSelected", [count]);
        } else if (count > 1 && count < 5) {
          return this.$t("labels.optionSelected", [count]);
        } else {
          return this.$t("labels.optionsSelected", [count]);
        }
      }
    },
    // set list of accessories with ID fetched from API
    setEquipment() {
      api.get("/filters/getAccessories").then((res) => {
        for (let item of res.data) {
          let icon;
          switch (item.Text) {
            case "bagażnik":
              icon = "konfigurator_bagazniki";
              break;
            case "błotniki":
              icon = "konfigurator_blotniki";
              break;
            case "fotelik dziecięcy":
              icon = "konfigurator_foteliki";
              break;
            case "koszyk na zakupy":
              icon = "konfigurator_koszyki";
              break;
            case "podpórka":
              icon = "konfigurator_podporka";
              break;
            case "przyczepka":
              icon = "konfigurator_przyczepka";
              break;
            case "torba lub sakwa":
              icon = "konfigurator_torby";
              break;
          }
          this.equipment.push({ id: item.Value, name: item.Text, icon });
        }
      });
    },
    onAreasCleared() {
      this.mainArea = null;
      this.optionalAreas = [];
    },
    onDestiniesCleared() {
      this.mainDestiny = null;
      this.optionalDestinies = [];
    },
  },
  created() {
    window.addEventListener("resize", this.windowResizeHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.windowResizeHandler);
  },
  async mounted() {
    this.setEquipment();
    //this.budget = [0, 17500];
    // set filters values depending on cookies
    this.getCookies();

    await this.getAreas();
    await this.getDestinies();

    this.areasOptions = Object.assign({}, ...this.areas.map((el) => ({ [el.Value]: el.Text })));
    this.destiniesOptions = Object.assign(
      {},
      ...this.destinies.map((el) => ({ [el.Value]: el.Text }))
    );

    setTimeout(() => {
      if (this.advancedFiltersOpen) {
        this.scrollToAdvancedFilters();
        this.advancedFiltersVisible = true;
      }
    }, 100);
    this.windowResizeHandler();
  },
  components: {
    AdvancedFilters,
    Slider,
    AreaModal,
    DestinyModal,
    Multiselect,
  },
};
</script>
<style scoped>
.fade-enter-active {
  transition: 0.5s ease;
}

.fade-leave-active {
  transition: 0.3s ease;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(10px);
}
</style>
<style src="@vueform/slider/themes/default.css"></style>
